import { render } from "./EditAddBescStep1Page.vue?vue&type=template&id=79a8c97a&ts=true"
import script from "./EditAddBescStep1Page.vue?vue&type=script&lang=ts"
export * from "./EditAddBescStep1Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__